import { useQuery } from 'react-query';
import { trackPromise } from 'react-promise-tracker';
import { getUsers } from '../index';
export const useGetUsers = (query) => useQuery(['GetUsers', query], () => trackPromise(getUsers(query)), {
    cacheTime: 0,
    // Не сбрасываем таблицу и списки фильтров в пустое состояние на время запроса.
    keepPreviousData: true,
});
